import { http } from "@canvas/api";
import { ECResp } from "./users/:userId/ecs";

export interface AllEcsReq {
  endpoint: "wakanda.api.v1.experience-centers";
}

export interface AllEcsRes {
  error: string;
  response: {
    results: ECResp[];
  };
}

export function get(req: AllEcsReq): Promise<AllEcsRes> {
  return http
    .GET(`/wakanda/api/v1/experience-centers`)
    .then((response: AllEcsRes) => {
      // validate response here
      return response;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
